export default "__VITE_ASSET__DglWpnsp__"